import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import styled from 'styled-components';
import { TextField, Typography, Button, Select, Checkbox } from '@quikr/ui';
import WhatsAppOpt from '@quikr/ui/src/common/WhatsAppOpt';

const FormWrapper = styled.div`
  max-height: 78vh;
  overflow-y: auto;
  margin: -15px;
  padding: 15px;
  padding-bottom: 170px;
  @media screen and (min-width: 768px) {
    max-height: 480px;
  }
`;
const ActionsWrapper = styled.div`
  background: #fff;
  z-index: 2;
  padding: 0 16px 15px;
  @media screen and (min-width: 768px) {
    padding-bottom: 20px;
  }
`;

const Skip = styled(Typography)`
  color: ${props => props.theme.colors.Primary};
  padding: 6px 30px;
  margin-right: 15px;
`;

const FileLabel = styled(Typography)`
  margin-bottom: 30px;
  border: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
  border-radius: 2px;
  height: 48px;
  line-height: 48px;
  padding-left: 12px;
  input {
    display: none;
  }
  span {
    background: ${({ theme }) => theme.colors.Neutral[100]};
    padding: 0 25px;
    font-weight: 500;
  }
  @media screen and (max-width: 767px) {
    height: 38px;
    line-height: 38px;
  }
`;

const FileError = styled(Typography)`
  color: ${({ theme }) => theme.colors.Error};
  top: 100%;
`;

const VIPRenew = styled.div`
  padding: 8px 42px;
  background: #fceb60;
  margin: -16px -24px 16px;
  gap: 16px;
  @media screen and (max-width: 767px) {
    padding: 8px 16px;
    margin: 0 -16px 16px;
  }
`;

const VIPRenewBtn = styled(Button)`
  background: ${({ theme }) => theme.colors.Primary};
  height: 35px;
  padding: 0 12px;
`;

const CheckBoxWrapper = styled.div`
  gap: 16px;
  margin: 16px 0 24px;
  > div {
    padding: 0;
  }
`;

const PACK_TYPE = 'VIP2';

const StepTwo = props => {
  const {
    action,
    setActionState,
    stepTwo,
    isMobile,
    role,
    id,
    user,
    close,
    changeView,
    stepTwoRequest,
    setApplicationInformation,
    fireGa,
    vipPackExpiryDaysLeft,
    products,
    getLinkRequest,
    getAndSetNiroOffer,
    hasNiroOffer
  } = props;
  const singleAnsTypes = ['RADIOBOX', 'DROPDOWN'];
  const stepTwoObj = {};
  const defaultFields = {};
  stepTwo.forEach(option => {
    stepTwoObj[option.id] = option;
    if (option.value_selected && option.value_selected.length > 0) {
      if (option.input_type === 'CHECKBOX') {
        defaultFields[option.id] = option.value_selected.map(item => {
          return item.id.toString();
        });
      } else if (singleAnsTypes.includes(option.input_type)) {
        defaultFields[option.id] = option.value_selected[0].id;
      } else {
        defaultFields[option.id] = option.value_selected[0].value;
      }
    }
  });
  const [reqError, setreqError] = useState('');
  const [fileError, setFileError] = useState({});
  const [fields, setFields] = useState(defaultFields);
  const [percentage, setPercentage] = useState(0);
  const uploadFile = (e, id) => {
    if (e.target.files[0]) {
      if (e.target.files[0].size < 1000000) {
        const url = 'https://raven.kuikr.com/upload2share';
        const headers = {
          'Content-Type': undefined
        };
        const data = new FormData();
        data.append('object', e.target.files[0]);
        const request = axios.post(url, data, headers);
        request
          .then(response => {
            if (response.status === 200) {
              setFields({
                ...fields,
                [id]: response.data.fileurl
              });
            }
          })
          .catch(error => {
            setFileError({ [id]: error });
          });
      } else {
        const { [id]: tmp, ...rest } = fields;
        setFields(rest);
        setFileError({ [id]: 'File size limit is 1Mb' });
      }
    }
  };
  const handleChange = (id, value, status) => {
    if (status !== 'error' && value) {
      setFields({
        ...fields,
        [id]: value
      });
    } else {
      const { [id]: tmp, ...rest } = fields;
      setFields(rest);
    }
    setreqError('');
  };
  const handleSelectChange = (values, name) => {
    setFields({
      ...fields,
      [name]: typeof values === 'object' ? values : [values]
    });
    setreqError('');
  };
  const handleClickSkip = () => {
    fireGa && fireGa('applyModal_step2_skip');
    close();
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (percentage > 0) {
      try {
        const answers = [];
        Object.keys(fields).forEach(key => {
          if (key === 'whatsAppOptInFlag') return;
          if (key === 'isPersonalLoanOpted') return;
          if (stepTwoObj[key].input_type === 'CHECKBOX') {
            const selectedAns = stepTwoObj[key].value_options.filter(option =>
              fields[key].includes(option.id.toString())
            );
            selectedAns.forEach(ans => {
              answers.push({ question_id: parseInt(key), answer_id: ans.id, answer: ans.value });
            });
          } else if (singleAnsTypes.includes(stepTwoObj[key].input_type)) {
            const answerIndex = stepTwoObj[key].value_options.findIndex(
              option => option.id === parseInt(fields[key])
            );
            answers.push({
              question_id: parseInt(key),
              answer_id: stepTwoObj[key].value_options[answerIndex].id,
              answer: stepTwoObj[key].value_options[answerIndex].value
            });
          } else {
            answers.push({ question_id: parseInt(key), answer_id: 0, answer: fields[key] });
          }
        });
        const formData = {
          ad: {
            id: parseInt(id),
            role: role
          },
          user: {
            id: parseInt(user.id),
            mobile: user.mobile,
            email: user.email
          },
          answers: answers,
          whatsappNotificationEnabled: fields.whatsAppOptInFlag || false
        };

        if (fields.isPersonalLoanOpted && getAndSetNiroOffer) {
          getAndSetNiroOffer();
        }

        const response = await stepTwoRequest({
          variables: { updatePayload: formData }
        });

        const { updateApplicationDetails } = response.data;
        if (updateApplicationDetails.type === 'SUCCESS') {
          if (setApplicationInformation) {
            setApplicationInformation(percentage);
          }
          setActionState({ action, status: true });
          !updateApplicationDetails.is_vip ? changeView('promotion') : close();
        } else {
          setreqError(updateApplicationDetails.error.description);
        }
        fireGa && fireGa('applyModal_step2_submit');
      } catch (e) {
        setreqError('Something went wrong! Please try again later');
      }
    } else {
      setreqError('Please fill the form and submit');
    }
  };
  useEffect(() => {
    const percent = parseInt((Object.keys(fields).length * 100) / stepTwo.length);
    setPercentage(percent);
  }, [fields, stepTwo]);

  const handleVIPRenewal = async e => {
    e.preventDefault();
    const formData = {
      user: {
        mobile: user.mobile,
        email: user.email
      },
      type: PACK_TYPE,
      utmParams: {
        utm_campaign: 'VIP_step2',
        utm_medium: 'Before_expiry',
        utm_source: 'VIP_new'
      }
    };
    if (user.id) {
      formData.user.id = parseInt(user.id);
    }
    const response = await getLinkRequest({
      variables: { payLoad: formData }
    });

    const data = response.data;
    if (data.getPaymentLink && data.getPaymentLink.paymentUrl) {
      fireGa && fireGa('applyModal_step2_vip_renew');
      setTimeout(() => (window.location.href = data.getPaymentLink.paymentUrl), 300);
    } else {
      setreqError('Something went wrong! Please try again later');
    }
  };

  const getPrice = type => {
    return products.filter(option => option.type === type)[0].price;
  };
  const vip2PackPrice = vipPackExpiryDaysLeft && getPrice(PACK_TYPE);

  return (
    <>
      {vipPackExpiryDaysLeft && vipPackExpiryDaysLeft >= 1 && vipPackExpiryDaysLeft <= 5 && (
        <VIPRenew className="dFA jcSB">
          <p className="bt1">
            Your <strong>VIP</strong> Subscription Expires{' '}
            {vipPackExpiryDaysLeft < 2
              ? 'tomorrow.'
              : `in ${Math.ceil(vipPackExpiryDaysLeft)} days.`}
          </p>
          <VIPRenewBtn
            onClick={handleVIPRenewal}
            btnType="primary"
            size="sm"
            type="button"
            className="wsN"
          >
            Renew at just ₹{vip2PackPrice}
          </VIPRenewBtn>
        </VIPRenew>
      )}
      <FormWrapper>
        <Typography className="form__heading" modifiers="bt2" tagName="p">
          Your application is <b>{percentage}% completed</b>. A complete profile gets faster jobs
        </Typography>
        {reqError && (
          <Typography className="form__error" modifiers="bt2" tagName="p">
            {reqError}
          </Typography>
        )}
        {stepTwo.map(field => {
          switch (field.input_type) {
            case 'FILE': {
              return (
                <FileLabel tagName="label" modifiers="bt2" className="pR dB" key={field.id}>
                  <input
                    key={field.id}
                    type="file"
                    onChange={e => uploadFile(e, field.id)}
                    /* eslint-disable-next-line max-len, no-useless-escape */
                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                  {fields[field.id] ? 'File uploaded' : 'Upload file'}
                  <span className="pA t0 r0 b0">Upload</span>
                  {fileError[id] && (
                    <FileError tagName="div" modifiers="bt3" className="pA l0">
                      fileError[id]
                    </FileError>
                  )}
                </FileLabel>
              );
            }
            case 'TEXTBOX': {
              let value = null;
              if (field.value_selected && field.value_selected.length > 0) {
                value = field.value_selected[0].value;
              }
              return (
                <TextField
                  key={field.id}
                  className="form__field"
                  inputName={field.id.toString()}
                  labelName={field.label}
                  type="text"
                  maxLength={30}
                  onBlur={(e, fieldState) =>
                    handleChange(field.id.toString(), e.target.value, fieldState)
                  }
                  value={value || ''}
                  required={field.mandatory}
                />
              );
            }
            case 'CHECKBOX': {
              let defaultValues = [];
              if (field.value_selected && field.value_selected.length > 0) {
                defaultValues = field.value_selected.map(item => {
                  return item.id.toString();
                });
              }
              return (
                <Select
                  key={field.id}
                  items={field.value_options}
                  onChange={handleSelectChange}
                  multiple={true}
                  labelText={field.label}
                  isMobile={isMobile}
                  valueKey="id"
                  labelKey="value"
                  name={field.id.toString()}
                  selectedVal={defaultValues}
                />
              );
            }
            case 'DROPDOWN':
            case 'RADIOBOX': {
              let defaultValue = null;
              if (field.value_selected && field.value_selected.length > 0) {
                defaultValue = field.value_selected[0].id.toString();
              }
              return (
                <Select
                  key={field.id}
                  items={field.value_options}
                  onChange={handleSelectChange}
                  multiple={false}
                  labelText={field.label}
                  isMobile={isMobile}
                  valueKey="id"
                  labelKey="value"
                  name={field.id.toString()}
                  selectedVal={defaultValue}
                />
              );
            }
            default:
              return <></>;
          }
        })}
      </FormWrapper>
      <ActionsWrapper className="taC pA l0 b0 w100">
        <CheckBoxWrapper className="dF fdC aiFS">
          <WhatsAppOpt
            onChange={(e, fieldState) =>
              handleChange('whatsAppOptInFlag', e.target.checked, 'success')
            }
          />
          {hasNiroOffer && (
            <div>
              <Checkbox
                className="bt2"
                name="isPersonalLoanOpted"
                onChange={e => handleChange('isPersonalLoanOpted', e.target.checked, 'success')}
                value="Yes, I need a personal loan"
              />
            </div>
          )}
        </CheckBoxWrapper>
        <div className="dFA jcC">
          {!isMobile && (
            <Skip tagName="span" modifiers="medium" className="cP" onClick={handleClickSkip}>
              Skip
            </Skip>
          )}
          <Button
            className="form__button"
            onClick={handleSubmit}
            btnType="primary"
            size="lg"
            type="button"
          >
            SUBMIT{isMobile && ' APPLICATION'}
          </Button>
        </div>
      </ActionsWrapper>
    </>
  );
};

StepTwo.propTypes = {
  id: PropTypes.string,
  role: PropTypes.string,
  stepTwo: PropTypes.array,
  isMobile: PropTypes.bool,
  state: PropTypes.object,
  action: PropTypes.string,
  user: PropTypes.object,
  close: PropTypes.func,
  changeView: PropTypes.func,
  setActionState: PropTypes.func,
  stepTwoRequest: PropTypes.func,
  setApplicationInformation: PropTypes.func,
  fireGa: PropTypes.func,
  vipPackExpiryDaysLeft: PropTypes.number,
  products: PropTypes.array,
  getLinkRequest: PropTypes.func,
  getAndSetNiroOffer: PropTypes.func,
  hasNiroOffer: PropTypes.bool
};

export default StepTwo;
